/* Linked engraving cart lines. Uses XHR to avoid the storefront's Rebuy fetch wrapper. */
(function () {
  'use strict';
  if (window.BellvariEngravingCart) return;
  const ID = '_bellvari_personalization_id';
  const ROLE = '_bellvari_role';
  const GIFT = '_bv_engraving_gift_for';
  const GIFT_GROUP = '_bv_gift_group';
  const GIFT_ROLE = '_bv_gift_role';
  let busy = false;
  let pendingAdd = null;
  let checkoutBypass = false;
  const route = path => ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + path;

  function xhr(method, url, body, timeout) {
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.open(method, url, true);
      request.timeout = timeout || 20000;
      request.setRequestHeader('Accept', 'application/json');
      if (body) request.setRequestHeader('Content-Type', 'application/json');
      request.onload = () => {
        let result;
        try { result = JSON.parse(request.responseText); }
        catch (_) { reject(new Error('The cart response could not be read.')); return; }
        if (request.status >= 200 && request.status < 300 && !result.errors) resolve(result);
        else reject(new Error(typeof result.description === 'string' ? result.description : typeof result.errors === 'string' ? result.errors : 'The cart could not be updated.'));
      };
      request.onerror = request.ontimeout = () => reject(new Error('The connection was interrupted.'));
      request.send(body ? JSON.stringify(body) : null);
    });
  }
  const read = () => xhr('GET', route('cart.js'));
  // Add to Bag and Check out read the cart first. One retry absorbs a dropped or rate-limited read.
  // If it still fails, plain items carry on (Shopify re-checks the cart); engraved items stay blocked.
  const guardRead = () => xhr('GET', route('cart.js'), null, 8000)
    .catch(() => new Promise(resolve => setTimeout(resolve, 600)).then(() => xhr('GET', route('cart.js'), null, 8000)));
  const engraved = items => (items || []).some(item => Object.keys(item.properties || {})
    .some(key => key.startsWith('_bellvari_') || key === GIFT || /^Engraving(?:$|\s)/.test(key)));
  function identity(item) {
    const properties = item.properties || {};
    return String(item.variant_id || item.id) + '|' + JSON.stringify(Object.keys(properties).sort().map(key => [key, String(properties[key])]));
  }
  function counts(items) {
    const result = new Map();
    for (const item of items || []) result.set(identity(item), (result.get(identity(item)) || 0) + Number(item.quantity));
    return result;
  }
  function validation(cart) {
    const items = cart.items || [];
    const linked = items.some(item => Object.keys(item.properties || {}).some(key => key.startsWith('_bellvari_') || /^Engraving(?:$|\s)/.test(key)));
    if (linked) {
      const contract = window.BellvariEngravingContract;
      if (!contract || typeof contract.validatePurchaseCart !== 'function') return { ok: false, error: 'Engraving details could not be checked. Refresh the page before checking out.' };
      const result = contract.validatePurchaseCart(items);
      if (!result.ok) return result;
    }
    const gifts = new Map();
    for (const item of items) {
      if (!Object.prototype.hasOwnProperty.call(item.properties || {}, GIFT)) continue;
      const id = item.properties[GIFT];
      if (typeof id !== 'string' || !id || !Number.isSafeInteger(item.quantity) || item.quantity < 1) {
        return { ok: false, error: 'This complimentary Care Kit could not be matched to its bag. Remove the Care Kit before checkout.' };
      }
      gifts.set(id, (gifts.get(id) || 0) + item.quantity);
    }
    for (const [id, quantity] of gifts) {
      const bags = items.filter(item => item.properties && item.properties[ID] === id && item.properties[ROLE] === 'bag');
      if (!bags.length) return { ok: false, error: 'This complimentary Care Kit needs its matching bag. Remove the Care Kit before checkout.' };
      const bagQuantity = bags.reduce((total, bag) => total + bag.quantity, 0);
      if (!Number.isSafeInteger(bagQuantity) || quantity > bagQuantity) return { ok: false, error: 'The complimentary Care Kit quantity exceeds its matching bag quantity. Reduce or remove the Care Kit before checkout.' };
    }
    const groups = new Map();
    for (const item of items) {
      const properties = item.properties || {};
      if (!Object.hasOwn(properties, GIFT_GROUP) && !Object.hasOwn(properties, GIFT_ROLE)) continue;
      const id = properties[GIFT_GROUP], role = properties[GIFT_ROLE];
      if (typeof id !== 'string' || !id || !['bag', 'gift'].includes(role) || !Number.isSafeInteger(item.quantity) || item.quantity < 1 || properties[ID] || properties[GIFT]) {
        return { ok: false, error: 'This complimentary Care Kit could not be matched to its bag. Remove the affected selection before checkout.' };
      }
      if (!groups.has(id)) groups.set(id, { bags: 0, gifts: 0, variants: new Set() });
      const group = groups.get(id);
      if (role === 'bag') { group.bags += item.quantity; group.variants.add(String(item.variant_id || item.id)); }
      else group.gifts += item.quantity;
    }
    for (const group of groups.values()) {
      if (!Number.isSafeInteger(group.bags) || group.variants.size > 1 || group.gifts > Math.min(1, group.bags)) {
        return { ok: false, error: 'Each complimentary Care Kit needs its matching bag. Reduce or remove the Care Kit before checkout.' };
      }
    }
    return { ok: true };
  }
  function showError(message, anchor) {
    let box = document.getElementById('bv-cart-action-error');
    if (!box) {
      box = document.createElement('p');
      box.id = 'bv-cart-action-error';
      box.setAttribute('role', 'alert');
      box.tabIndex = -1;
      box.style.cssText = 'padding:12px 16px;margin:12px 0;border:1px solid #9b3b29;background:#fffaf3;color:#702819;font:400 16px/1.5 Inter,Arial,sans-serif;';
    }
    const host = anchor && anchor.closest && anchor.closest('.drawer__inner, cart-items, [data-bv-form]') || document.querySelector('cart-drawer.active .drawer__inner') || document.querySelector('[data-bv-form]') || document.querySelector('main') || document.body;
    if (box.parentNode !== host) host.appendChild(box);
    box.textContent = message;
    box.hidden = false;
    box.focus({ preventScroll: false });
    return box;
  }
  function clearError() {
    const box = document.getElementById('bv-cart-action-error');
    if (box) box.hidden = true;
  }
  function sections() {
    const plans = [];
    const drawer = document.querySelector('cart-drawer');
    const cart = document.querySelector('cart-items');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      drawer.getSectionsToRender().forEach(item => plans.push({ ...item, section: item.id, drawer: true }));
    }
    if (cart && typeof cart.getSectionsToRender === 'function') plans.push(...cart.getSectionsToRender());
    const ids = [...new Set(plans.map(item => item.section))];
    return { plans, ids: ids.length ? ids.slice(0, 5) : ['cart-drawer', 'cart-icon-bubble'] };
  }
  function render(response, openDrawer) {
    const drawer = document.querySelector('cart-drawer');
    const plan = sections();
    const nativeDrawer = drawer && typeof drawer.renderContents === 'function' && response.sections && response.sections['cart-drawer'] && (openDrawer || drawer.classList.contains('active'));
    if (nativeDrawer) drawer.renderContents(response);
    if (response.sections) {
      for (const item of plan.plans) {
        if (nativeDrawer && item.drawer) continue;
        const html = response.sections[item.section];
        if (!html) continue;
        const target = document.getElementById(item.id) || (item.selector && document.querySelector(item.selector));
        if (!target) continue;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const source = parsed.querySelector(item.selector || '.shopify-section');
        const destination = target.querySelector(item.selector || '.shopify-section') || target;
        if (source) destination.innerHTML = source.innerHTML;
      }
    }
    if (!nativeDrawer && drawer) {
      const overlay = document.getElementById('CartDrawer-Overlay');
      if (overlay) overlay.onclick = () => drawer.close();
    }
    if (typeof response.item_count === 'number') {
      document.querySelectorAll('cart-drawer, cart-items, #main-cart-footer').forEach(el => el.classList.toggle('is-empty', response.item_count === 0));
    }
    if (openDrawer && !nativeDrawer && drawer && typeof drawer.open === 'function') drawer.open();
    document.dispatchEvent(new CustomEvent('bellvari:cart-updated', { detail: response }));
  }
  async function refresh(openDrawer) {
    const cart = await read();
    const ids = sections().ids;
    const markup = await xhr('GET', route('cart') + '?sections=' + encodeURIComponent(ids.join(',')));
    const result = { ...cart, sections: markup };
    render(result, openDrawer);
    return result;
  }
  async function reconcilePending(clearAbsent = true) {
    if (!pendingAdd) return { status: 'none' };
    const currentCart = await read();
    const current = counts(currentCart.items);
    const absent = [...pendingAdd.delta].every(([key]) => (current.get(key) || 0) === (pendingAdd.before.get(key) || 0));
    const complete = [...pendingAdd.delta].every(([key, qty]) => (current.get(key) || 0) === (pendingAdd.before.get(key) || 0) + qty);
    if (complete) {
      pendingAdd = null;
      let response = currentCart;
      try { response = await refresh(true); }
      catch (_) { showError('Your items were added. Open your cart to review them; the cart display could not refresh.'); }
      return { status: 'added', response };
    }
    if (absent) { if (clearAbsent) pendingAdd = null; return { status: 'absent' }; }
    throw new Error('The cart changed during the interrupted add. Review the items in your cart before trying again.');
  }
  async function guardedAdd(items, options, beforePost) {
    if (busy) throw new Error('Your cart is updating. Please wait.');
    busy = true;
    try {
      const prior = await reconcilePending();
      if (prior.status === 'added') return prior.response;
      const candidate = validation({ items });
      if (!candidate.ok) throw new Error(candidate.error || 'The engraving details are incomplete. Review the selection before adding it.');
      let before = null;
      try { before = await guardRead(); }
      catch (_) { if (engraved(items)) throw new Error('We could not check your cart, so your engraved bag was not added. Check your connection and tap Add to Bag again.'); }
      const checked = before ? validation(before) : { ok: true };
      if (!checked.ok) throw new Error('Review the engraving items already in your cart before adding another bag.');
      if (beforePost) await beforePost();
      pendingAdd = before ? { before: counts(before.items), delta: counts(items) } : null;
      try {
        const response = await xhr('POST', route('cart/add.js'), { items, ...options });
        pendingAdd = null;
        return response;
      } catch (error) {
        try {
          const result = await reconcilePending(false);
          if (result.status === 'added') return result.response;
        } catch (_) {
          throw new Error('The connection was interrupted. We could not confirm whether the items were added. Check your cart before trying again.');
        }
        throw error;
      }
    } finally { busy = false; }
  }
  async function updatePair(personalizationId, quantity, anchor, change) {
    if (busy) { showError('Your cart is updating. Please wait.', anchor); return false; }
    if (!Number.isSafeInteger(quantity) || quantity < 0) { showError('Enter a whole quantity of zero or more.', anchor); return false; }
    busy = true;
    clearError();
    try {
      const cart = await read();
      const linked = cart.items.filter(item => item.properties && item.properties[ID] === personalizationId);
      const gifts = cart.items.filter(item => item.properties && item.properties[GIFT] === personalizationId);
      if (!linked.length && !(quantity === 0 && gifts.length)) { await refresh(false); return true; }
      const checkedCart = validation(cart);
      const removeGroup = !change && quantity === 0;
      const groupContract = window.BellvariEngravingContract;
      const checkedGroup = typeof groupContract?.validatePurchaseCart === 'function' ? groupContract.validatePurchaseCart(linked) : { ok: false };
      const repairGroup = change?.remove === true && !checkedGroup.ok;
      const removing = removeGroup || change?.remove === true;
      if (!removing && (!checkedCart.ok || linked.some(item => !['bag', 'fee'].includes(item.properties[ROLE])))) {
        throw new Error('These engraving items do not match. Remove this personalized selection and add it again.');
      }
      const bags = linked.filter(item => item.properties[ROLE] === 'bag');
      const fees = linked.filter(item => item.properties[ROLE] === 'fee');
      let selected = null;
      let selectedQuantity = null;
      let targetQuantity = repairGroup ? 0 : quantity;
      if (change && !repairGroup) {
        const roleLines = change.role === 'fee' ? fees : bags;
        selected = change.rowKey ? roleLines.find(item => item.key === change.rowKey) : roleLines.length === 1 ? roleLines[0] : null;
        if (!selected) throw new Error('Your cart changed. Review the current quantities and try again.');
        selectedQuantity = change.remove ? 0 : change.delta !== undefined ? Math.max(0, selected.quantity + change.delta) : quantity;
        targetQuantity = roleLines.reduce((total, item) => total + item.quantity, 0) - selected.quantity + selectedQuantity;
        if (!Number.isSafeInteger(selectedQuantity) || selectedQuantity < 0 || !Number.isSafeInteger(targetQuantity) || targetQuantity < 0) {
          throw new Error('Enter a whole quantity of zero or more.');
        }
      }
      const updates = Object.create(null);
      function allocate(roleLines) {
        if (!roleLines.length) return;
        if (selected && roleLines.includes(selected)) {
          // Only the interacted row changes. Shopify can redistribute discount
          // allocations afterwards; another split row must not multiply with it.
          roleLines.forEach(item => { updates[item.key] = item === selected ? selectedQuantity : item.quantity; });
          return;
        }
        let remaining = targetQuantity;
        for (const item of roleLines) {
          const next = Math.min(item.quantity, remaining);
          updates[item.key] = next;
          remaining -= next;
        }
        if (remaining) updates[roleLines[0].key] += remaining;
      }
      if (removeGroup || repairGroup) linked.forEach(item => { updates[item.key] = 0; });
      else { allocate(bags); allocate(fees); }
      // Keep the one-per-add gift optional, cap it when bags decrease, and remove it with its own bag.
      let giftAllowance = targetQuantity;
      for (const gift of gifts) {
        const next = Math.min(Number(gift.quantity), giftAllowance);
        if (next !== gift.quantity) updates[gift.key] = next;
        giftAllowance -= next;
      }
      const response = await xhr('POST', route('cart/update.js'), { updates, sections: sections().ids, sections_url: window.location.pathname });
      render(response, false);
      const verified = await read();
      const checked = validation(verified);
      if (!checked.ok) throw new Error(checked.error || 'The bag and engraving quantities do not match. Review or remove this personalized selection before checkout.');
      const verifiedQuantity = verified.items.filter(item => item.properties?.[ID] === personalizationId && item.properties[ROLE] === 'bag').reduce((total, item) => total + item.quantity, 0);
      if (verifiedQuantity !== targetQuantity) throw new Error('Your cart quantity changed. Review the current quantity before checking out.');
      const updatedRow = [...document.querySelectorAll('[data-bv-personalization-id]')].find(row => row.dataset.bvPersonalizationId === personalizationId);
      const focusTarget = updatedRow && quantityInput(updatedRow) || document.querySelector('cart-drawer.active .drawer__close, #CartDrawer-Checkout, [name="checkout"], .cart-item__name');
      if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus();
      return true;
    } catch (error) {
      try { await refresh(false); } catch (_) {}
      showError(error.message || 'The engraving quantity could not be updated.', anchor?.isConnected === false ? null : anchor);
      return false;
    } finally { busy = false; }
  }
  async function updateGiftGroup(groupId, quantity, anchor, change) {
    if (busy) { showError('Your cart is updating. Please wait.', anchor); return false; }
    if (!Number.isSafeInteger(quantity) || quantity < 0) { showError('Enter a whole quantity of zero or more.', anchor); return false; }
    busy = true; clearError();
    try {
      const cart = await read();
      const linked = cart.items.filter(item => item.properties?.[GIFT_GROUP] === groupId);
      if (!linked.length) { await refresh(false); return true; }
      const bags = linked.filter(item => item.properties[GIFT_ROLE] === 'bag');
      const gifts = linked.filter(item => item.properties[GIFT_ROLE] === 'gift');
      const role = change?.role || 'bag';
      if (!['bag', 'gift'].includes(role)) throw new Error('Your cart changed. Review the current selection and try again.');
      const removing = change?.remove === true || !change && quantity === 0;
      if (!removing && !validation(cart).ok) throw new Error('Review the complimentary Care Kit and its matching bag before changing quantities.');
      const roleLines = role === 'gift' ? gifts : bags;
      const selected = change ? change.rowKey ? roleLines.find(item => item.key === change.rowKey) : roleLines.length === 1 ? roleLines[0] : null : null;
      if (change && !selected) throw new Error('Your cart changed. Review the current quantities and try again.');
      const currentBags = bags.reduce((sum, item) => sum + item.quantity, 0);
      const currentGifts = gifts.reduce((sum, item) => sum + item.quantity, 0);
      const selectedQuantity = selected ? change.remove ? 0 : change.delta !== undefined ? Math.max(0, selected.quantity + change.delta) : quantity : null;
      const target = selected ? (role === 'gift' ? currentGifts : currentBags) - selected.quantity + selectedQuantity : quantity;
      if (!Number.isSafeInteger(target) || target < 0 || selected && (!Number.isSafeInteger(selectedQuantity) || selectedQuantity < 0)) throw new Error('Enter a whole quantity of zero or more.');
      const bagQuantity = role === 'bag' ? target : currentBags;
      const giftQuantity = role === 'gift' ? target : Math.min(currentGifts, bagQuantity);
      if (giftQuantity > Math.min(1, bagQuantity)) throw new Error('Each bag selection includes one complimentary Care Kit. Keep its quantity at one or remove it.');
      const updates = Object.create(null);
      function allocate(lines, count) {
        if (selected && lines.includes(selected)) {
          lines.forEach(item => { updates[item.key] = item === selected ? selectedQuantity : item.quantity; });
          return;
        }
        let remaining = count;
        for (const item of lines) { const next = Math.min(item.quantity, remaining); if (next !== item.quantity) updates[item.key] = next; remaining -= next; }
        if (remaining && lines.length) updates[lines[0].key] = (updates[lines[0].key] ?? lines[0].quantity) + remaining;
      }
      allocate(bags, bagQuantity); allocate(gifts, giftQuantity);
      const response = await xhr('POST', route('cart/update.js'), { updates, sections: sections().ids, sections_url: window.location.pathname });
      render(response, false);
      const verified = await read(), checked = validation(verified);
      if (!checked.ok) throw new Error(checked.error);
      const remaining = verified.items.filter(item => item.properties?.[GIFT_GROUP] === groupId);
      const count = role => remaining.filter(item => item.properties[GIFT_ROLE] === role).reduce((sum, item) => sum + item.quantity, 0);
      if (count('bag') !== bagQuantity || count('gift') !== giftQuantity) throw new Error('Your cart quantity changed. Review the current quantity before checking out.');
      const updatedRow = [...document.querySelectorAll('[data-bv-gift-group-id]')].find(row => row.dataset.bvGiftGroupId === groupId);
      const focusTarget = updatedRow && quantityInput(updatedRow) || document.querySelector('cart-drawer.active .drawer__close, #CartDrawer-Checkout, [name="checkout"], .cart-item__name');
      focusTarget?.focus();
      return true;
    } catch (error) {
      try { await refresh(false); } catch (_) {}
      showError(error.message || 'The bag and complimentary Care Kit could not be updated.', anchor?.isConnected === false ? null : anchor);
      return false;
    } finally { busy = false; }
  }
  function stop(event) { event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation(); }
  function linkedRow(target) { return target.closest && target.closest('[data-bv-personalization-id]:not([data-bv-personalization-id=""])'); }
  function giftRow(target) { return target.closest && target.closest('[data-bv-gift-group-id]:not([data-bv-gift-group-id=""])'); }
  function quantityInput(row) { return row.querySelector('input[name="updates[]"], input.quantity__input'); }
  function rowChange(row, change = {}) {
    return { rowKey: row.dataset.bvLineKey || null, role: row.dataset.bvPersonalizationRole || 'bag', ...change };
  }
  // An engraved bag's complimentary Care Kit (_bv_engraving_gift_for) renders as a plain row, so + on it added a
  // paid second kit and then blocked checkout (fix 2026-09-23). When the cart holds an engraved bag, check the
  // row's line first: refuse a kit increase like the plain-bag kit row does, and hand every other change back.
  let giftBypass = false;
  function guardEngravingGift(event) {
    const input = event.target;
    const row = input.closest('[data-bv-line-key]:not([data-bv-line-key=""])');
    if (giftBypass || !row || !document.querySelector('[data-bv-personalization-id]:not([data-bv-personalization-id=""])')) return;
    stop(event);
    read().then(cart => cart.items.find(item => item.key === row.dataset.bvLineKey), () => null).then(item => {
      if (item && Object.hasOwn(item.properties || {}, GIFT) && Number(input.value) > item.quantity) {
        input.value = item.quantity;
        showError('Each bag selection includes one complimentary Care Kit. Keep its quantity at one or remove it.', input);
        return;
      }
      if (!input.isConnected) return;
      giftBypass = true;
      try { input.dispatchEvent(new Event('change', { bubbles: true })); } finally { giftBypass = false; }
    });
  }
  document.addEventListener('click', event => {
    const row = linkedRow(event.target);
    if (row) {
      const remove = event.target.closest('cart-remove-button, [data-bv-remove-personalization]');
      const stepper = event.target.closest('button[name="plus"], button[name="minus"]');
      if (remove || stepper) {
        stop(event);
        const input = quantityInput(row);
        const current = input ? Number(input.value) : 1;
        const next = remove ? 0 : current + (stepper.name === 'plus' ? 1 : -1);
        updatePair(row.dataset.bvPersonalizationId, Math.max(0, next), event.target,
          rowChange(row, remove ? { remove: true } : { delta: stepper.name === 'plus' ? 1 : -1 }));
        return;
      }
    }
    const plain = giftRow(event.target);
    if (plain) {
      const remove = event.target.closest('cart-remove-button');
      const stepper = event.target.closest('button[name="plus"], button[name="minus"]');
      if (remove || stepper) {
        stop(event);
        const current = Number(quantityInput(plain)?.value || 1);
        const delta = stepper?.name === 'plus' ? 1 : -1;
        updateGiftGroup(plain.dataset.bvGiftGroupId, remove ? 0 : Math.max(0, current + delta), event.target,
          { rowKey: plain.dataset.bvLineKey, role: plain.dataset.bvGiftGroupRole, ...(remove ? { remove: true } : { delta }) });
        return;
      }
    }
    const checkout = event.target.closest && event.target.closest('button[name="checkout"], input[name="checkout"], a[href^="/checkout"], a[href*="/checkouts/"]');
    if (checkout && !checkoutBypass) { stop(event); guardCheckout(() => { checkoutBypass = true; try { checkout.click(); } finally { checkoutBypass = false; } }, checkout); }
  }, true);
  document.addEventListener('change', event => {
    const row = linkedRow(event.target);
    if (!event.target.matches('input[name="updates[]"], input.quantity__input')) return;
    if (!row) {
      const plain = giftRow(event.target);
      if (plain) { stop(event); updateGiftGroup(plain.dataset.bvGiftGroupId, Number(event.target.value), event.target, { rowKey: plain.dataset.bvLineKey, role: plain.dataset.bvGiftGroupRole }); }
      else guardEngravingGift(event);
      return;
    }
    stop(event);
    updatePair(row.dataset.bvPersonalizationId, Number(event.target.value), event.target, rowChange(row));
  }, true);
  document.addEventListener('submit', event => {
    if (checkoutBypass) return;
    const form = event.target;
    const submitter = event.submitter;
    if (submitter && submitter.name === 'checkout' || form.matches('form[action*="/checkout"]')) {
      stop(event);
      guardCheckout(() => { checkoutBypass = true; try { form.requestSubmit(submitter); } finally { checkoutBypass = false; } }, submitter || form);
    }
  }, true);
  async function guardCheckout(proceed, anchor) {
    if (busy) { showError('Your cart is updating. Wait for it to finish before checkout.', anchor); return false; }
    busy = true;
    try {
      await reconcilePending();
      let cart;
      try { cart = await guardRead(); }
      catch (_) {
        if (document.querySelector('[data-bv-personalization-id]:not([data-bv-personalization-id=""])')) {
          throw new Error('We could not check your engraved items. Check your connection and tap Check out again.');
        }
        proceed();
        return true;
      }
      const result = validation(cart);
      if (!result.ok) throw new Error(result.error || 'Your engraving items need attention. The bag and engraving fee must match. Remove the personalized selection and add it again before checkout.');
      proceed();
      return true;
    } catch (error) { showError(error.message || 'We could not check your cart. Please try checkout again.', anchor); return false; }
    finally { busy = false; }
  }
  window.BellvariEngravingCart = { xhr, read, refresh, render, guardedAdd, reconcilePending, updatePair, updateGiftGroup, guardCheckout, showError, clearError, get busy() { return busy; } };
})();
